import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import fonts from 'bitmovin-web-ui/src/styles/fonts';
import normalizeCss from 'bitmovin-web-ui/src/styles/normalize';
import {Link as RouterLink} from 'react-router-dom';
import styled, {injectGlobal} from 'styled-components';

const defaultAppFontSizePx: number = 14;
const smallScreenDefaultAppFontSizePx: number = 11.5;
export const maxExtendedWidth = '1600px';
export const orangeColorRGB = '#ff6b00';
export const pxToEm = (px: number): number => px / defaultAppFontSizePx;

export function injectAppGlobalStyles(): void {
  // tslint:disable-next-line
  injectGlobal`
${normalizeCss}

${fonts}

* {
  box-sizing: border-box;
}

html {
  height: 100%;
  scroll-behavior: smooth;
  font-family: 'averta', 'sans-serif';
  font-size: ${defaultAppFontSizePx / baseVariables.sizes.defaultBrowserFontSizePx}em;
  padding: 0;
  margin: 0;
  
  @media (max-width: ${maxExtendedWidth}) {
     font-size: ${smallScreenDefaultAppFontSizePx / baseVariables.sizes.defaultBrowserFontSizePx}em;
  }
}

body {
  height: 100%;
  font-family: averta, sans-serif;
  text-rendering: optimizeLegibility;
  color: ${baseVariables.colors.dusk};
}

button {
   font-size: 1em !important;
}

#root {
  height: 100%;
}

#__next {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

address {
  font-style: normal;
}

hr {
  border: none;
  border-bottom: 1px solid ${baseVariables.colors.lightBlueGray};
  margin: 2em 0;
}


/** TABLE START **/

table {
  max-width: 100%;
  border-collapse: collapse;
  overflow-x: auto;
}

tr {
    transition: background 0.15s ease-out, box-shadow;
}
tr:hover {
    background: ${baseVariables.colors.lightBlueGray};
}
thead > tr:hover {
    background: none;
}

th {
    color: ${baseVariables.colors.midnight};
    font-weight: bold;
}

td, th {
    text-align: center;
    padding: 10px 20px;
    border-bottom: 1px solid ${baseVariables.colors.lightBlueGray};
}

td:first-child {
    text-align: left;
}

sup {
    margin: 0.3em;
}

a {
  color: ${baseVariables.colors.bitmovinBlue};
  text-decoration: none;
}

/** TABLE END **/

/** helper class to prevent scrolling when hamburger menu is open **/
.no-scroll {
    overflow: hidden;
    height: 100%;
    @media (min-width: 71em) {
        overflow: auto;
        height: auto;
    }
}
`;
}

export const Link = styled(RouterLink)`
  text-decoration: none;
  cursor: pointer;
  color: ${baseVariables.colors.dusk};
`;

export const ExternalLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${baseVariables.colors.dusk};
`;

export const StyledPageCenterContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${maxExtendedWidth}) {
    padding-right: 6em;
    padding-left: 6em;
  }

  > * {
    width: 100%;
    max-width: ${baseVariables.sizes.maxWidth};
  }
`;
